// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rpv-page-navigation__current-page-input{margin:0 .25rem;text-align:right;width:3rem}
`, "",{"version":3,"sources":["webpack://./node_modules/@react-pdf-viewer/page-navigation/lib/styles/index.css"],"names":[],"mappings":"AAAA,yCAAyC,eAAe,CAAC,gBAAgB,CAAC,UAAU","sourcesContent":[".rpv-page-navigation__current-page-input{margin:0 .25rem;text-align:right;width:3rem}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
